import { getApplicationStateIdentifier } from '@resistdesign/voltra/app/utils';

const ADD_MESSAGE = getApplicationStateIdentifier();
const MESSAGES = getApplicationStateIdentifier();

export const INTERVIEW = getApplicationStateIdentifier({
  ADD_MESSAGE,
  MESSAGES,
});
